var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$vuetify.breakpoint.mobile)?_c('Mobile'):_vm._e(),(!_vm.$vuetify.breakpoint.mobile)?_c('Pc'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }